import MapGeofence from './MapGeofence'
export default MapGeofence;


// WEBPACK FOOTER //
// ./src/common/components/MapGeofence/index.js